import React, { useContext } from "react"
import { Box } from "@mui/material"
import TableStyleContext from "../TableStyleContext"
import ReportingSystemMessage from "../../ReportingSystemMessage"
import { EMPTY_MESSAGE_DATA_BY_TYPE, NoDataType } from "../constants"
import { CustomEmptyMessage } from "../Table"
import TableCell from "./TableCell"

type Props = {
  columns: number
  type: NoDataType
  customMessage?: CustomEmptyMessage
}

const EmptyPlaceholder: React.FC<Props> = ({
  columns,
  type = NoDataType.NO_DATA,
  customMessage
}) => {
  const { cx, classes } = useContext(TableStyleContext)

  const messageData = customMessage || EMPTY_MESSAGE_DATA_BY_TYPE[type]

  return (
    <Box
      role="row"
      className={cx(classes.row, classes.rowNoHover)}
      data-autiomation-id="data-table-row"
    >
      <TableCell
        role="cell"
        colSpan={columns}
        className={cx(
          classes.bodyTableCell,
          classes.tableCell,
          classes.emptyPlaceholder
        )}
        data-autiomation-id="data-table-placeholder"
      >
        <ReportingSystemMessage
          title={messageData.title}
          text={messageData.text}
          icon={messageData.icon}
          iconColor={messageData.iconColor}
          iconBgColor={messageData.iconBgColor}
          size="sm"
        />
      </TableCell>
    </Box>
  )
}

export default EmptyPlaceholder
